import { useEffect, useState } from "react";
import moment from "moment";
import { reformatData } from "../helperFunctions";
import { fetchExpressions } from "../../api/sensorApi";

const panel_start = "2016-01-01";
const panel_end = moment().format("YYYY-MM-DD");
const panel_interval = "D";


export const useEvalMetrics = (path, id, units, expressions) => {
    const [evalData, setEvalData] = useState();
    useEffect(() => {
        const body = {}
        if (path == "SensorExpression") {
            body.subject_filter = `sensor.id ='${id}'`;
        } else {
            body.ids = [id];
        }
        fetchExpressions(path, {
            ...body,
            expressions: expressions(),
            start: panel_start,
            end: panel_end,
            interval: panel_interval,
        })
            .then((data) => {
                const formattedData = reformatData([data])[0];
                console.log("Eval Data:", formattedData);
                setEvalData(formattedData);
            })
            .catch((error) => {
                console.error("Error fetching eval metrics:", error);
            });

    }, [path, id, units, expressions]);

    return evalData;
};